import { useQuery } from '@tanstack/react-query'
import { api } from './api'

// Someone you're connected to: in the tree of one of your circles, a member of one, or connected one to one, once
// however many circles they're in. personId is their page, when they have one (someone who joined a circle without a family tree has none).
export type MyPerson = {
  key: string
  personId: string | null
  name: string
  living: boolean
  born: string | null
  died: string | null
  pet: boolean
  portrait: string | null
  me: boolean
  account: boolean
  // Connected one to one (missing from an older server: no).
  connected?: boolean
  circles: { id: string; name: string }[]
}

export const useMyPeople = () =>
  useQuery({
    queryKey: ['my-people'],
    queryFn: async () => (await api<{ people: MyPerson[] }>('/my-people')).people,
  })
